import { bl_alg_cc_qc_hdr_RowClass as bl_alg_cc_qc_hdr_RowClass } from "../../../../dbschema/bl_alg_cc_qc_hdr.model";
import { BaseContainerModel } from "../../../base-container.model";

export class QualityControlHdrContainerModel extends BaseContainerModel {

    bl_alg_cc_qc_hdr: bl_alg_cc_qc_hdr_RowClass = new bl_alg_cc_qc_hdr_RowClass();        
}
